"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SEGMENT = exports.FONT_TYPE = exports.PRICE_OPACITY = exports.PRICE_DECORATION = exports.PRICE_SIZE = exports.PRICE_COLOR = exports.convertToOptions = exports.parsePrice = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

require("./price.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var parsePrice = function parsePrice(number) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var decimalChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var thousandChar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var res = number;
  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);
  var splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);

  if (splitNum[1] !== '00') {
    res = splitNum.join(decimalChar);
  } else {
    res = splitNum[0];
  }

  return res;
};

exports.parsePrice = parsePrice;

var convertToOptions = function convertToOptions(optionsObject) {
  var keys = Object.keys(optionsObject);
  return keys.map(function (key) {
    return optionsObject[key];
  });
};

exports.convertToOptions = convertToOptions;
var PRICE_COLOR = {
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  EGG: 'egg',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  BLUE_DARK: 'dark-blue',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  CORAL: 'coral',
  DARK_GREEN: 'dark-green',
  MEDIUM_GREEN: 'medium-green',
  LIGHT_GREEN: 'light-green',
  DARK_ORANGE: 'dark-orange',
  MEDIUM_ORANGE: 'medium-orange',
  LIGHT_ORANGE: 'light-orange',
  LIGHT_BLUE: 'light-blue',
  MEDIUM_BLUE: 'medium-blue',
  DARK_BLUE: 'dark-blue',
  DARK_PURPLE: 'dark-purple',
  MEDIUM_PURPLE: 'medium-purple',
  LIGHT_PURPLE: 'light-purple',
  RED: 'red',
  DARK_YELLOW: 'dark-yellow',
  MEDIUM_YELLOW: 'medium-yellow',
  LIGHT_YELLOW: 'light-yellow',
  ORCHID_DARK: 'orchid-dark'
};
exports.PRICE_COLOR = PRICE_COLOR;
var PRICE_SIZE = {
  SMALL: 'small',
  REGULAR: 'regular',
  EMP_40: 'emp-40',
  EMP_30: 'emp-30',
  EMP_28: 'emp-28',
  EMP_22: 'emp-22',
  EMP_18: 'emp-18'
};
exports.PRICE_SIZE = PRICE_SIZE;
var PRICE_DECORATION = {
  LINE_THROUGH: 'linethrough',
  UNDERLINE: 'underline',
  NONE: 'none'
};
exports.PRICE_DECORATION = PRICE_DECORATION;
var PRICE_OPACITY = {
  OP_1: 'op-1',
  OP_0_5: 'op-0-5',
  OP_0_25: 'op-0-25'
};
exports.PRICE_OPACITY = PRICE_OPACITY;
var FONT_TYPE = {
  REGULAR: 'font-regular',
  LIGHT: 'font-light',
  THIN: 'font-thin',
  BOLD: 'font-bold',
  HAND: 'font-hand'
};
exports.FONT_TYPE = FONT_TYPE;
var SEGMENT = {
  PARTICULARES: 'particulares',
  GP: 'gp',
  EMP: 'emp',
  EMPRESAS: 'empresas'
};
/**
 * Stateless component to draw a price
 * @param {string} amount Price amount
 * @param {string} unity it is currency: €, or for example: €/mes
 * @param {string} color text color: allows: PRICE_COLOR .
 * @param {string} decoration extra decoration for component allows: PRICE_DECORATION
 * @param {string} size text fontsize allows: PRICE_SIZE
 * @param {bool} withSpace space between  amount and unity
 * @param {string} opacity text opacity
 * @param {string} fontType text fontsize allows: FONT_TYPE
 * @returns {JSX} Component JSX.
 */

exports.SEGMENT = SEGMENT;

var Price = function Price(props) {
  var myProps = (0, _gerenciatdUtils2.setUpPropsByDevice)(props);
  var amount = myProps.amount,
      unity = myProps.unity,
      size = myProps.size,
      color = myProps.color,
      decoration = myProps.decoration,
      withSpace = myProps.withSpace,
      opacity = myProps.opacity,
      fontType = myProps.fontType,
      segment = myProps.segment;

  if (!amount) {
    (0, _gerenciatdUtils.errorLog)('[Price]: amount must be !== null');
    return null;
  }

  var finalAmount = parsePrice(amount);
  var sizeCss = " price_size--".concat(size);
  var decorationCss = decoration ? " price_decoration--".concat(decoration) : '';
  var colorCss = color ? " price_color-".concat(segment, "--").concat(color) : '';
  var AmountUnityLabel = withSpace ? "".concat(finalAmount, " ").concat(unity) : "".concat(finalAmount).concat(unity);
  var opacityCss = " price_opacity--".concat(opacity);
  var fontTypeCss = fontType ? " price_".concat(segment, "--").concat(fontType) : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "price".concat(sizeCss).concat(colorCss).concat(decorationCss).concat(opacityCss).concat(fontTypeCss),
    children: AmountUnityLabel
  });
};

Price.propTypes = {
  /**
   * {
   *  "info": "Establece la cantidad a mostrar en el componente",
   *  "kind": "both",
   *  "beautifulName": "Cantidad"
   * }
   */
  amount: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * {
   *  "info": "Establece la unidad con la que mostrar la cantidad en el componente",
   *  "kind": "both",
   *  "beautifulName": "Unidad"
   * }
   */
  unity: _propTypes["default"].string,

  /**
   * {
   *  "info": "Define el color del componente en el array PRICE_COLOR",
   *  "kind": "both",
   *  "beautifulName": "Color"
   * }
   */
  color: _propTypes["default"].oneOf(convertToOptions(PRICE_COLOR)),

  /**
   * {
   *  "info": "Establece el tamaño del texto del componente: regular(24px) o small(16px)",
   *  "kind": "both",
   *  "beautifulName": "Tamaño texto"
   * }
   */
  size: _propTypes["default"].oneOf(convertToOptions(PRICE_SIZE)),

  /**
   * {
   *  "info": "Establece la decoración del texto del componente: none, line_through, underline",
   *  "kind": "both",
   *  "beautifulName": "Decoración texto"
   * }
   */
  decoration: _propTypes["default"].oneOf(convertToOptions(PRICE_DECORATION)),

  /**
   * {
   *  "info": "Establece si existe un espacio entre la cantidad y la unidad",
   *  "kind": "both",
   *  "beautifulName": "Espacio entre la cantidad y la unidad"
   * }
  */
  withSpace: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Establece la opacidad del elemento",
   *  "kind": "both",
   *  "beautifulName": "Opacidad"
   * }
  */
  opacity: _propTypes["default"].oneOf(convertToOptions(PRICE_OPACITY)),

  /**
   * {
   *  "info": "Define la fuente del componente según los tipos definidos en el array FONT_TYPE",
   *  "kind": "both",
   *  "beautifulName": "Fuente del texto"
   * }
   */
  fontType: _propTypes["default"].oneOf(convertToOptions(FONT_TYPE)),

  /**
   * {
   *  "info": "Necesita para especificar el segmento",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes["default"].oneOf(convertToOptions(SEGMENT))
};
Price.defaultProps = {
  unity: '€',
  size: PRICE_SIZE.REGULAR,
  color: PRICE_COLOR.ORANGE,
  decoration: PRICE_DECORATION.NONE,
  withSpace: true,
  opacity: PRICE_OPACITY.OP_1,
  segment: SEGMENT.GP
};
var _default = Price;
exports["default"] = _default;

//# sourceMappingURL=index.js.map